import LightRays from './LightRays';
import './App.css';

function App() {
  return (
    <div
      className="hero-rays-wrapper">
      
      <LightRays
        raysOrigin="top-center"
        raysColor="#ffffff"
        raysSpeed={1}
        lightSpread={0.5}
        rayLength={3}
        followMouse={true}
        mouseInfluence={0.1}
        noiseAmount={0}
        distortion={0}
        className="custom-rays"
      />
    </div>
  );
}

export default App;
